exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".remove-para-margin p{margin:0}.remove-para-margin>br{display:none}.ql-background{background-color:transparent!important}", ""]);

// exports
